import { array, Describe, is, number, optional, string, type } from 'superstruct';

export const IconVariationValidator = type({
  downloadUrl: string(),
  extension: string(),
  fileName: string(),
  fileSize: optional(number()),
  id: number(),
  shortDescription: optional(string()),
  title: optional(string()),
});

type IconVariationDto = {
  downloadUrl: string;
  extension: string;
  fileName: string;
  fileSize: number;
  id: number;
  shortDescription: string;
  title: string;
};

export const isIconVariation = (obj: unknown) => is(obj, IconVariationValidator);

export const IconVariationsValidator: Describe<IconVariationDto[]> = array(IconVariationValidator);
export const isIconVariations = (obj: unknown) => is(obj, IconVariationsValidator);
